<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>

<p class="text-center text-3xl font-hairline text-blue-500 mb-4">{{ 'ForNqtSetData' | translate }}:</p>
<!-- <p class="my-2 text-xl text-center"> {{ 'PayForTry' | translate}}</p> -->
<form action="" [formGroup]="applicationForm">
    <div class="flex mb-4">
        <div class="w-1/5 h-1 bg-blue-300 mt-4">
        </div>
        <div class="w-3/5 text-center text-3xl font-hairline uppercase tracking-widest">
            {{ 'PersonalData' | translate }}
        </div>
        <div class="w-1/5 h-1 bg-blue-300 mt-4">
        </div>
    </div>
    <div class="flex py-1">
        <div class="w-1/3">
            {{ 'IIN' | translate }}
        </div>
        <div class="w-1/3">
            <input disabled readonly (keyup)="changeIIN()" [mask]="iin" formControlName="iin" class="border h-6 rounded" type="text">
        </div>
    </div>
    <!-- <div (click)="findData(applicationForm.get('iin').value)" class="w-full bg-blue-700 rounded border-dark border my-4 cursor-pointer text-center py-1 hover:bg-blue-500 text-lg text-white font-bold tracking-widest">
        {{ 'SearchByIIN' | translate }}
    </div> -->
    <div class="flex py-3">
        <div class="w-1/3">
            {{ 'Surname' | translate }}
        </div>
        <div class="w-1/3">
            <input disabled readonly formControlName="lastname" class="border h-6 rounded" type="text">
        </div>
    </div>
    <div class="flex py-3">
        <div class="w-1/3">
            {{ 'Name' | translate }}
        </div>
        <div class="w-1/3">
            <input disabled readonly formControlName="firstname" class="border h-6 rounded" type="text">
        </div>
    </div>
    <div class="flex py-3">
        <div class="w-1/3">
            {{ 'Patronymic' | translate }}
        </div>
        <div class="w-1/3">
            <input disabled readonly formControlName="patronymic" class="border h-6 rounded" type="text">
        </div>
    </div>
    <div class="flex py-3">
        <div class="w-1/3">
            {{ 'YourEmail' | translate }}
        </div>
        <div class="w-1/3">
            <input disabled readonly formControlName="email" class="border h-6 rounded" type="text">
        </div>
    </div>
    <div class="flex py-3">
        <div class="w-1/3">
            {{ 'PhoneNumber' | translate }}
        </div>
        <div class="w-1/3">
            <input [mask]="phone" formControlName="phoneNumber" class="border h-6 rounded" type="text">
        </div>
    </div>
    <div class="py-3">
        {{ 'DiplomName' | translate }}:
    </div>
    <div class="">
        <select formControlName="eduSpecialityId" class="w-full border my-1" name="">
            <option selected disabled value="-1">
                --
            </option>
            <option [ngValue]="item.id" *ngFor="let item of instituteSpecialityList">
                <span *ngIf="translate.currentLang == 'kz'">{{ item.code }} - {{ item.name.kk }}</span>
                <span *ngIf="translate.currentLang == 'ru'">{{ item.code }} - {{ item.name.ru }}</span>
            </option>
        </select>
    </div>
    <div class="flex mb-4">
        <div class="w-1/5 h-1 bg-blue-300 mt-4">
        </div>
        <div class="w-3/5 text-center text-3xl font-hairline uppercase tracking-widest">
            {{ 'PlaceOfStudy' | translate }}
        </div>
        <div class="w-1/5 h-1 bg-blue-300 mt-4">
        </div>
    </div>

    <div class="flex py-3">
        <div class="w-1/3">
            {{ 'SelectObl' | translate }}:
        </div>
        <div class="w-2/3">
            <select class="border" formControlName="eduInstituteOblId" (change)="getInstitute()">
                <option selected disabled value="-1">
                    {{ 'SelectObl' | translate }}
                </option>
                <option *ngFor="let obl of oblList" [ngValue]="obl.id">
                    <span *ngIf="translate.currentLang == 'kz'">{{ obl.name.kk }} </span>
                    <span *ngIf="translate.currentLang == 'ru'">{{ obl.name.ru }} </span>
                </option>
            </select>

        </div>
    </div>

    <div class="flex py-3">
        <div class="w-1/3">
            {{ 'VUZofStudy' | translate }}:
        </div>
        <div class="w-2/3">
            <select class="border" formControlName="eduInstituteId">
                <option selected disabled value="-1">
                    {{ 'VUZofStudy' | translate }}
                </option>
                <option *ngFor="let inst of instituteList" [ngValue]="inst.id">
                    <span *ngIf="translate.currentLang == 'kz'">{{ inst.name.kk }} </span>
                    <span *ngIf="translate.currentLang == 'ru'">{{ inst.name.ru }} </span>
                </option>
            </select>

        </div>
    </div>

    <div class="flex mb-4">
        <div class="w-1/5 h-1 bg-blue-300 mt-4">
        </div>
        <div class="w-3/5 text-center text-3xl font-hairline uppercase tracking-widest">
            {{ 'TestParams' | translate }}
        </div>
        <div class="w-1/5 h-1 bg-blue-300 mt-4">
        </div>
    </div>
    <div [formArrayName]="subjects" class="py-3" *ngFor="let item of subjects.controls; index as i">
        <div class="">
            <div class="">
                <div class="">
                    {{ 'TestBlock' | translate }}
                </div>
                <div>
                    <select class="w-full border" (change)="setSubjectValue(0, i, $event.target.value)">
                        <option selected value="-1">
                            --
                        </option>
                        <option [value]="sub.id" *ngFor="let sub of subjectList[i]">
                            <span *ngIf="translate.currentLang == 'kz'">{{ sub.name.kk }}</span>
                            <span *ngIf="translate.currentLang == 'ru'">{{ sub.name.ru }}</span>
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="pb-3">
        <div class="">
            <div class="">
                {{ 'TestLang' | translate }}
            </div>
            <select formControlName="testLangId" class="w-full border my-1" name="">
                <option selected disabled value="-1">
                    --
                </option>
                <option [ngValue]="item.id" *ngFor="let item of langList">
                    <span *ngIf="translate.currentLang == 'kz'">{{ item.name.kk }}</span>
                    <span *ngIf="translate.currentLang == 'ru'">{{ item.name.ru }}</span>
                </option>
            </select>
        </div>
    </div>
    <div class="w-full">
        <select (change)="getTestOrgList()" formControlName="oblId" class="w-full border my-1" name="">
            <option selected disabled value="-1">
                {{ 'SelectTestObl' | translate }}
            </option>
            <option [ngValue]="item.id" *ngFor="let item of oblList">
                <span *ngIf="translate.currentLang == 'kz'">{{ item.name.kk }}</span>
                <span *ngIf="translate.currentLang == 'ru'">{{ item.name.ru }}</span>
            </option>
        </select>
        <select (change)="getTestPeriodList()" formControlName="testOrgId" class="w-full border my-1" name="">
            <option selected disabled value="-1">
                {{ 'TestPlace' | translate }}
            </option>
            <option [ngValue]="item.id" *ngFor="let item of testOrg">
                <span *ngIf="translate.currentLang == 'kz'">{{ item.name.kk }}</span>
                <span *ngIf="translate.currentLang == 'ru'">{{ item.name.ru }}</span>
            </option>
        </select>
        <select formControlName="testPeriodId" class="w-full border my-1" name="">
            <option selected disabled value="-1">
                {{ 'TestTime' | translate }}
            </option>
            <option [ngValue]="item.id" *ngFor="let item of testPeriod">
                <span *ngIf="translate.currentLang == 'kz'">{{ item.testDate }} ({{ 'FreePlaceCount' | translate }}: {{ item.freePlaceCount }}) </span>
                <span *ngIf="translate.currentLang == 'ru'">{{ item.testDate }} ({{ 'FreePlaceCount' | translate }}: {{ item.freePlaceCount }}) </span>
            </option>
        </select>
    </div>
  <form [formGroup]="applicationForm" action="">
    <button (click)="textModal = true"
            class=" bg-blue-500 hover:bg-blue-700 w-full cursor-pointer text-center p-2 text-white mt-8 mobile-style-3">
      {{ 'Continue' | translate }}
    </button>
  </form>
  <div *ngIf="textModal == true" class="overlay">
    <div class="modal-window">
      <div class="relative">
        <div class="modal-sub-header">
          {{ 'PeredPod' | translate }}
        </div>
        <div (click)="closeAgreeModal()" class="text-red-500 absolute right-0 top-0 cursor-pointer font-bold">
          X
        </div>
      </div>
      <div (scroll)="onScrollEnd($event)" class="modal-text">
      <span>
                <div *ngIf="!rulesEnt; else showRulesEnt">
                    <div *ngIf="translate.currentLang === 'ru'"
                         [innerHTML]="sanitizer.bypassSecurityTrustHtml(rulesOzpData.contentRus)"></div>
                    <div *ngIf="translate.currentLang === 'kz'"
                         [innerHTML]="sanitizer.bypassSecurityTrustHtml(rulesOzpData.contentKaz)"></div>
                </div>
                <ng-template #showRulesEnt>
                    <div *ngIf="translate.currentLang === 'ru'"
                         [innerHTML]="sanitizer.bypassSecurityTrustHtml(rulesOzpData.contentRus)">
                    </div>
                    <div *ngIf="translate.currentLang === 'kz'"
                         [innerHTML]="sanitizer.bypassSecurityTrustHtml(rulesOzpData.contentKaz)">
                    </div>
                </ng-template>
            </span>
      </div>
      <form [formGroup]="applicationForm" action="">
        <div *ngIf="!rulesEnt" class="text-center">
          <div>
            <input (change)="rulesEnt = true" type="checkbox" id="get-agree" class="get-agreement">
            <label class="ml-2" for="get-agree">{{ 'RulesText-4' | translate }}</label>
          </div>
        </div>
        <div *ngIf="rulesEnt">
          <div class="help-text">
            *{{ 'ReadT' | translate }}
          </div>
          <div class="text-center">
            <input formControlName="applicationAgree" (change)="agreeCheck($event)"
                   type="checkbox" id="get-agree" class="get-agreement">
            <label class="ml-2" for="get-agree">{{ 'ProbSog' | translate }}</label>
          </div>
        </div>
        <div class="w-full text-center">
          <button [disabled]="!(applicationForm.get('applicationAgree').value)" (click)="closeForModal()"
                  class="btn btn-primary w-full">
            {{ 'Continue' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>



  <!--  <form [formGroup]="applicationForm" action="">-->
  <!--    <button (click)="textModal = true"-->
  <!--            class=" bg-blue-500 hover:bg-blue-700 w-full cursor-pointer text-center p-2 text-white mt-8 mobile-style-3">-->
  <!--      {{ 'Continue' | translate }}-->
  <!--    </button>-->
  <!--  </form>-->
  <div *ngIf="textOfModal == true" class="overlay">
    <div class="modal-window">
      <div class="relative">
        <div class="modal-sub-header">
          {{ 'PeredPodOf' | translate }}
        </div>
        <div (click)="closeAgreeOfModal()" class="text-red-500 absolute right-0 top-0 cursor-pointer font-bold">
          X
        </div>
      </div>
      <div (scroll)="onScrollOfEnd($event)" class="modal-text">
      <span>
                <div *ngIf="!rulesEnt; else showRulesEnt">
                    <div *ngIf="translate.currentLang === 'ru'"
                         [innerHTML]="sanitizer.bypassSecurityTrustHtml(rulesOfData.contentRus)"></div>
                    <div *ngIf="translate.currentLang === 'kz'"
                         [innerHTML]="sanitizer.bypassSecurityTrustHtml(rulesOfData.contentKaz)"></div>
                </div>
                <ng-template #showRulesEnt>
                    <div *ngIf="translate.currentLang === 'ru'"
                         [innerHTML]="sanitizer.bypassSecurityTrustHtml(rulesOfData.contentRus)">
                    </div>
                    <div *ngIf="translate.currentLang === 'kz'"
                         [innerHTML]="sanitizer.bypassSecurityTrustHtml(rulesOfData.contentKaz)">
                    </div>
                </ng-template>
            </span>
      </div>
      <form [formGroup]="applicationForm" action="">
        <div *ngIf="!rulesOf" class="text-center">
          <div>
            <input (change)="rulesOf = true" type="checkbox" id="get-agree" class="get-agreement">
            <label class="ml-2" for="get-agree">{{ 'OfFog' | translate }}</label>
          </div>
        </div>
        <div *ngIf="rulesOf">
          <div class="help-text">
            *{{ 'ReadT' | translate }}
          </div>
          <div class="text-center">
            <input formControlName="applicationAgreeOf" (change)="agreeCheckOf($event)"
                   type="checkbox" id="get-agree" class="get-agreement">
            <label class="ml-2" for="get-agree">{{ 'OfFog' | translate }}</label>
          </div>
        </div>
        <div class="w-full text-center">
          <button [disabled]="!(applicationForm.get('applicationAgreeOf').value)" (click)="postForm()"
                  class="btn btn-primary w-full">
            {{ 'PostApplication' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>


</form>
